import { Button as MuiButton } from '@mui/material';
import { styled } from '@mui/material/styles';
const StyledButton = styled(MuiButton)(({ theme: { palette } }) => ({
    '&.MuiButtonBase-root.MuiButton-root.Mui-disabled': {
        color: palette.primary.light,
    },
    '&.MuiButton-root.MuiButton-contained.Mui-disabled': {
        backgroundColor: palette.primary.light,
        color: palette.common.white,
    },
    '&.Mui-disabled.MuiButton-text .MuiButton-startIcon': {
        color: palette.primary.light,
    },
}));
// https://mui.com/material-ui/guides/typescript/#complications-with-the-component-prop
export default StyledButton;
